import React from 'react';
import { Button, Dialog, Grow, IconButton } from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import '../Modal/modal.scss';

const SmoothGrow = React.forwardRef(function SmoothGrow(props, ref) {
  return <Grow ref={ref} timeout={{ enter: 320, exit: 200 }} {...props} />;
});

const DeleteTaskStatus = ({ open, handleClose, handleDelete }) => {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="delete-status-dialog-title"
      aria-describedby="delete-status-dialog-description"
      maxWidth="xs"
      fullWidth
      TransitionComponent={SmoothGrow}
      PaperProps={{ className: 'pj-modal pj-modal--danger' }}
      slotProps={{ backdrop: { className: 'pj-modal-backdrop' } }}
    >
      <div className="pj-modal-body">
        <IconButton className="pj-modal-close" size="small" onClick={handleClose} aria-label="Close">
          <CloseRoundedIcon fontSize="small" />
        </IconButton>

        <span className="pj-modal-badge">
          <DeleteOutlineRoundedIcon />
        </span>

        <h3 className="pj-modal-title" id="delete-status-dialog-title">
          Delete issue status
        </h3>
        <p className="pj-modal-sub" id="delete-status-dialog-description">
          This removes the swimlane from the board. It can only go once no issues
          are using it. This cannot be undone.
        </p>
      </div>

      <div className="pj-modal-actions">
        <Button className="pj-btn pj-btn--quiet" onClick={handleClose}>
          Cancel
        </Button>
        <Button className="pj-btn pj-btn--primary" onClick={handleDelete} autoFocus>
          Yes, delete
        </Button>
      </div>
    </Dialog>
  );
};

export default DeleteTaskStatus;
